module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-art-5.0919f79b.jpg";